// src/pages/module2/PhaseIntro.js

import React from "react";
import { useParams, useNavigate } from "react-router-dom";

const PHASE_TEXT = {
  1: {
    title: "Presence",
    text: `I want to slow things down here.
Before anything else, I’m interested in how present you actually are — with yourself, with this process, and with the other person.
Presence is not about effort.
It’s about whether you are here, or already elsewhere.
As you enter this phase, notice what you tend to avoid feeling or naming.
Notice what you rush past.
That matters more than getting anything “right.”`
  },
  2: {
    title: "Emotional Dynamics",
    text: `Here we turn toward how emotions move between you.
Not what you say about them —
but how they appear, shift, escalate, withdraw, or get managed.
Some emotions are expressed directly.
Others show up indirectly, through tone, control, or silence.
As you go on, pay attention to what you allow yourself to feel,
and what you try to contain, shape, or hide.`
  },
  3: {
    title: "Conflict & Friction",
    text: `This phase looks at where things rub, clash, or tighten.
Conflict is not the problem.
What matters is how it is handled, displaced, or avoided.
Sometimes friction is loud.
Sometimes it’s quiet and chronic.
As you enter, stay close to your own reactions.
Especially the ones you usually justify or minimize.`
  },
  4: {
    title: "Intimacy & Sexuality",
    text: `Here we move into a more vulnerable terrain.
Intimacy is not only physical.
It’s about access, openness, and exposure.
Sexuality carries desire, fear, power, and meaning — often at the same time.
Go slowly here.
Notice where you feel open, and where you pull back.
Both are important signals.`
  },
  5: {
    title: "Meaning & Direction",
    text: `This phase looks beyond the immediate moment.
What are you orienting toward?
What gives this connection weight, direction, or purpose?
Meaning isn’t something you declare —
it’s something that shows through choices and consistency.
As you continue, notice what you’re actually moving toward,
not just what sounds right to say.`
  }
};

export default function PhaseIntro() {

  const { sessionId, role, phase } = useParams();
  const navigate = useNavigate();

  const phaseData = PHASE_TEXT[Number(phase)];

  if (!phaseData) {
    navigate(`/module2/${sessionId}/${role}`);
    return null;
  }

  function handleContinue() {
    navigate(`/module2/checkin/${sessionId}/${role}/${phase}`);
  }

  return (

    <div
      style={{
        minHeight: "100vh",
        padding: "120px 28px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        background:
          "radial-gradient(circle at 50% 45%, #123044 0%, #081822 55%, #020608 100%)",

        fontFamily: "Inter, sans-serif",
        color: "#F5F4ED"
      }}
    >

      <div
        style={{
          maxWidth: 640,
          width: "100%",

          background: "rgba(18,48,68,0.35)",
          border: "1px solid rgba(245,244,237,0.25)",
          borderRadius: 22,

          padding: "42px 36px",

          backdropFilter: "blur(8px)",

          textAlign: "center"
        }}
      >

        <h2
          style={{
            fontFamily: "Cormorant Garamond, serif",
            fontSize: 28,
            fontWeight: 400,
            marginBottom: 26
          }}
        >
          {phaseData.title}
        </h2>

        <p
          style={{
            fontFamily: "Cormorant Garamond, serif",
            fontSize: 18,
            lineHeight: 1.85,
            letterSpacing: "0.03em",
            whiteSpace: "pre-line",
            color: "rgba(245,244,237,0.9)"
          }}
        >
          {phaseData.text}
        </p>

        <button
          onClick={handleContinue}
          style={{
            marginTop: 46,
            padding: "10px 30px",

            fontSize: 15,
            cursor: "pointer",

            background: "#F5F4ED",
            color: "#081822",

            border: "none",
            borderRadius: 20,

            fontWeight: 500,

            boxShadow: "0 0 14px rgba(245,244,237,0.35)"
          }}
        >
          Continue
        </button>

      </div>

    </div>
  );
} 